import React from "react";
import { Modal } from "react-bootstrap";
import CompareTable from "./CompareTable";

function CompareModal({ title, choices, selected, selectChoice, handleClose }) {
  return (
    <Modal show={true} onHide={handleClose} dialogClassName="wide-modal">
      <Modal.Header closeButton>
        <Modal.Title>{title} Comparison</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CompareTable
          title={title}
          choices={choices}
          currentValue={selected}
          handleSelect={selectChoice}
        />
      </Modal.Body>
    </Modal>
  );
}

export default CompareModal;
